export class StockAdjustmentModal {
  constructor() {
    this.operator = '';
    this.quantity = '0';
  }
}
